import { render } from "./TourView.vue?vue&type=template&id=61fb1e86&scoped=true"
import script from "./TourView.vue?vue&type=script&lang=js"
export * from "./TourView.vue?vue&type=script&lang=js"

import "./TourView.vue?vue&type=style&index=0&id=61fb1e86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fb1e86"]])

export default __exports__